import React from 'react';
import { compose } from 'redux';
import { pages as PAGES } from 'containers/Landing/constants';
import withLanding from 'containers/Landing/withLanding';
import withContent from 'components/Content/withContent';
import Hero from 'components/Hero';
import Categories from './Categories';
import Dispensers from './Dispensers';

import styles from './styles.scss';

const CONTENT_KEYS = {
  equipments: 'Equipments',
  hero: 'Hero',
};

const CONTENT_TYPE_KEYS = {
  categories: 'productCategory',
};

const Showcase = ({ content }) => (
  <>
    <Hero content={content.hero} className={styles.hero} />
    <Categories content={content.categories} />
    <Dispensers content={content.equipments} />
  </>
);

export default compose(
  withLanding(PAGES.homeOfficeProducts),
  withContent(CONTENT_KEYS, CONTENT_TYPE_KEYS),
)(Showcase);
